import React from "react";
import { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import Loading from "../general/Loading";
import { Link } from "react-router-dom";
import FormNuevaCita from "./FormNuevaCita";
import { Toast, ToastContainer, Modal } from "react-bootstrap";
import { leadingZero, getAmpm, getHoraCita, convertirHoraMilitarA12h, getElementosHora } from "../../../resources/Helper";
import { buildCitaTooltipHtml, calcularPosicionTooltipCita } from "../../../resources/agendaTooltipContent";
import AgendaTooltip from "../custom/AgendaTooltip";
import CustomSwitch from "../custom/CustomSwitch";

function VistaPorRecursos(props) {

    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const [recursos, setRecursos] = useState([]);
    const [todosLosRecursos, setTodosLosRecursos] = useState([]); // Lista completa sin filtrar
    const [recursosSeleccionados, setRecursosSeleccionados] = useState([]); // IDs de recursos seleccionados
    const [mostrarFiltros, setMostrarFiltros] = useState(false);

    const [alturaAgendaRecursos, setAlturaAgendaRecursos] = useState();
    const [bloquesMinutos, setBloquesMinutos] = useState();
    const [contenidoRecursos, setContenidoRecursos] = useState();
    const [etiquetasHoras, setEtiquetasHoras] = useState();

    const [fechaAgendaRecursos, setFechaAgendaRecursos] = useState();
    const [fechaUnix, setFechaUnix] = useState();
    const [showDateModal, setShowDateModal] = useState(false);
    const [fechaModal, setFechaModal] = useState('');

    const [stepCita, setStepCita] = useState();


    ////////////////////////////////////////////////////

    const [date, setDate] = useState('');
    const [time, setTime] = useState('');
    const [modalState, setModalState] = useState('hidden');
    const [extendedProps, setExtendedProps] = useState({});
    const [idCita, setIdCita] = useState('');
    const [idPaciente, setIdPaciente] = useState('');
    const [primerNombre, setPrimerNombre] = useState('');
    const [segundoNombre, setSegundoNombre] = useState('');
    const [primerApellido, setPrimerApellido] = useState('');
    const [segundoApellido, setSegundoApellido] = useState('');
    const [email, setEmail] = useState('');
    const [celular, setCelular] = useState('');
    const [tipoDocumento, setTipoDocumento] = useState('');
    const [numeroDocumento, setNumeroDocumento] = useState('');
    const [duracionCita, setDuracionCita] = useState('');
    const [estadoCita, setEstadoCita] = useState('');
    const [idEstadoCita, setIdEstadoCita] = useState('');
    const [unidadAtencion, setUnidadAtencion] = useState('');
    const [motivoConsulta, setMotivoConsulta] = useState('');
    const [citaPaciente, setCitaPaciente] = useState('');
    const [descripcionCita, setDescripcionCita] = useState('');
    const [verCita, setVerCita] = useState(false);
    const [puedeAtender, setPuedeAtender] = useState('');
    const [estadoPaciente, setEstadoPaciente] = useState('');
    const [idUsuarioAgenda, setIdUsuarioAgenda] = useState('');
    const [idUnidadAgenda, setIdUnidadAgenda] = useState('');
    const [primeraVez, setPrimeraVez] = useState();
    const [horaAtencionCita, setHoraAtencionCita] = useState();
    const [minutoCita, setMinutoCita] = useState();
    const [ampmCita, setAmpmCita] = useState();
    const [profesionalAsignado, setProfesionalAsignado] = useState();
    const [usuarioAgenda, setUsuarioAgenda] = useState();
    const [nombreProfesionalAsignado, setNombreProfesionalAsignado] = useState('');
    const [nombreUsuarioAsigna, setNombreUsuarioAsigna] = useState('');
    const [toastMsg, setToastMsg] = useState('');
    const [showToast, setShowToast] = useState(false);

    const [tooltipTop, setTooltipTop] = useState();
    const [tooltipLeft, setTooltipLeft] = useState();
    const [tooltipDisplay, setTooltipDisplay] = useState('none');
    const [tooltipAnchor, setTooltipAnchor] = useState(null);
    const [contenidoTooltip, setContenidoTooltip] = useState('');
    const tooltipHideTimerRef = useRef(null);

    const clearTooltipHideTimer = () => {
        if (tooltipHideTimerRef.current) {
            clearTimeout(tooltipHideTimerRef.current);
            tooltipHideTimerRef.current = null;
        }
    };

    // Estados para horarios de agenda
    const [horaInicio, setHoraInicio] = useState(0); // Hora en formato 24h (0-23)
    const [horaFin, setHoraFin] = useState(24); // Hora en formato 24h (0-24)

    ////////////////////////////////////////////////////


    let userdata = [];

    const SLOT_DURACION = parseInt(stepCita || 30, 10);
    // Con steps cortos (10/15 min) 64px/hora deja filas ilegibles; forzar mínimo ~22px por celda
    const MIN_PIXELS_POR_SLOT = 22;
    const PIXELS_POR_HORA = Math.max(64, Math.ceil((MIN_PIXELS_POR_SLOT * 60) / Math.max(SLOT_DURACION, 1)));
    const SCALE_MINUTOS_POR_PIXEL = 60 / PIXELS_POR_HORA;
    const HEADER_ALTURA = 44;

    useEffect(() => {
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
            setStepCita(userdata.step);
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        axios.get('/get-client?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {

                console.log(error);
            });

        // ✅ Cargar horarios de agenda
        axios.get('/horario-agenda')
            .then(response => {
                if (response.status === 200) {
                    const inicio = parseInt(response.data.hora_inicio.split(':')[0]);
                    const fin = parseInt(response.data.hora_fin.split(':')[0]);
                    
                    // Si es el rango por defecto (00:00 - 23:59), usar 24 horas completas
                    if (inicio === 0 && fin === 23) {
                        setHoraInicio(0);
                        setHoraFin(24);
                    } else {
                        setHoraInicio(inicio);
                        setHoraFin(fin + 1); // +1 para incluir la última hora
                    }
                }
            })
            .catch(error => {
                console.log('Usando horarios por defecto (24h)');
            });


        ////////////////////////////////

        crearBloquesMinutos(SLOT_DURACION, SCALE_MINUTOS_POR_PIXEL);

        let fechaHoy = new Date();
        let dia = fechaHoy.getDate();
        let mes = fechaHoy.getMonth() + 1;
        let anyo = fechaHoy.getFullYear();

        let fechaAgenda = anyo + '-' + leadingZero(mes) + '-' + leadingZero(dia);

        setFechaAgendaRecursos(fechaAgenda);

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                fecha: fechaAgenda
            }
        }

        axios.get('citas-profesionales-dia', config2)
            .then(response => {
                if (response.status === 200) {
                    setTodosLosRecursos(response.data);
                    // Inicialmente seleccionar todas las agendas
                    const idsAgendas = response.data.map(agenda => agenda.agenda_id || agenda.id);
                    setRecursosSeleccionados(idsAgendas);
                    setRecursos(response.data);
                }
            })
            .catch(error => console.log(error))


        setFechaUnix(new Date().getTime());

    }, []);

    useEffect(() => () => clearTooltipHideTimer(), []);

    useEffect(() => {
        renderizarRecursos(SLOT_DURACION, SCALE_MINUTOS_POR_PIXEL, recursos);
    }, [recursos, SLOT_DURACION, SCALE_MINUTOS_POR_PIXEL]);

    // ✅ Regenerar bloques cuando cambien los horarios
    useEffect(() => {
        crearBloquesMinutos(SLOT_DURACION, SCALE_MINUTOS_POR_PIXEL);
    }, [horaInicio, horaFin, SLOT_DURACION, SCALE_MINUTOS_POR_PIXEL]);

    // Efecto para filtrar recursos cuando cambian las selecciones
    useEffect(() => {
        if (todosLosRecursos.length > 0) {
            const recursosFiltrados = todosLosRecursos.filter(agenda =>
                recursosSeleccionados.includes(agenda.agenda_id || agenda.id)
            );
            setRecursos(recursosFiltrados);
        }
    }, [recursosSeleccionados, todosLosRecursos]);


    useEffect(() => {
        cargarCitas(fechaAgendaRecursos);
    }, [fechaAgendaRecursos]);


    function handleFecha(dias) {

        let c = dias * 86400000;
        let nuevaFecha = new Date(fechaUnix + c);
        setFechaUnix(fechaUnix + c);

        let fc = new Date(fechaUnix + c);

        let dia = fc.getDate();
        let mes = fc.getMonth() + 1;
        let anyo = fc.getFullYear();

        setFechaAgendaRecursos(anyo + '-' + leadingZero(mes) + '-' + leadingZero(dia));
    }

    function handleFechaDirecta(fechaSeleccionada) {
        // Convertir la fecha seleccionada a timestamp Unix
        let fechaObj = new Date(fechaSeleccionada + 'T00:00:00');
        setFechaUnix(fechaObj.getTime());
        setFechaAgendaRecursos(fechaSeleccionada);
    }

    function formatearFechaAmigable(fechaIso) {
        if (!fechaIso || typeof fechaIso !== 'string' || fechaIso.indexOf('-') === -1) return fechaIso || '';
        const [y, m, d] = fechaIso.split('-').map(n => parseInt(n, 10));
        if (!y || !m || !d) return fechaIso;
        const fechaLocal = new Date(y, m - 1, d);
        const texto = fechaLocal.toLocaleDateString('es-CO', {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
        return texto.charAt(0).toUpperCase() + texto.slice(1);
    }

    const abrirModalFecha = () => {
        const hoy = new Date();
        const hoyStr = `${hoy.getFullYear()}-${leadingZero(hoy.getMonth() + 1)}-${leadingZero(hoy.getDate())}`;
        setFechaModal(fechaAgendaRecursos || hoyStr);
        setShowDateModal(true);
    };

    const aplicarFechaModal = () => {
        if (fechaModal) {
            handleFechaDirecta(fechaModal);
        }
        setShowDateModal(false);
    };

    const irHoyDesdeModal = () => {
        const hoy = new Date();
        const hoyStr = `${hoy.getFullYear()}-${leadingZero(hoy.getMonth() + 1)}-${leadingZero(hoy.getDate())}`;
        setFechaModal(hoyStr);
        handleFechaDirecta(hoyStr);
        setShowDateModal(false);
    };


    const handleClicCalendar = (e, agenda) => {  // ← Cambiado de "citas" a "agenda"
        let rect = e.target.getBoundingClientRect();
        let y = (e.clientY - rect.top) - HEADER_ALTURA;
        let duracionBloquePixels = parseInt(SLOT_DURACION / SCALE_MINUTOS_POR_PIXEL, 10);
        let slot = parseInt(y / duracionBloquePixels);

        // ✅ Calcular minutos desde el inicio configurado
        let minutoDia = (horaInicio * 60) + (SLOT_DURACION * slot);

        let horaNuevaCita = parseInt(minutoDia / 60);
        let minutoNuevaCita = minutoDia % 60;
        let fechaNuevaCita = leadingZero(horaNuevaCita) + ':' + leadingZero(minutoNuevaCita) + ':00';

        // Limpiar estado de edición previa: click en espacio vacío debe abrir nueva cita
        setVerCita(false);
        setPrimeraVez(true);
        setIdCita('');
        setIdPaciente('');
        setPrimerNombre('');
        setSegundoNombre('');
        setPrimerApellido('');
        setSegundoApellido('');
        setEmail('');
        setCelular('');
        setTipoDocumento('');
        setNumeroDocumento('');
        setEstadoCita('');
        setIdEstadoCita('');
        setUnidadAtencion('');
        setMotivoConsulta('');
        setCitaPaciente('');
        setDescripcionCita('');
        setPuedeAtender(false);
        setEstadoPaciente('');

        setDate(fechaAgendaRecursos);
        setHoraAtencionCita(getHoraCita(horaNuevaCita));
        setMinutoCita(leadingZero(minutoNuevaCita));
        setAmpmCita(getAmpm(horaNuevaCita));

        // Usar agenda_id en lugar de id
        setProfesionalAsignado(agenda.agenda_id);

        // Usar nombre_agenda
        setNombreProfesionalAsignado(agenda.nombre_agenda);

        setModalState('visible');
    }

    function renderizarRecursos(duracionBloque, minutosPorPixel, arrayCitas) {

        // ✅ Calcular altura basada en el rango configurado
        const minutosRango = (horaFin - horaInicio) * 60;
        let h = parseInt(minutosRango / minutosPorPixel);
        let duracionBloquePixels = parseInt(duracionBloque / minutosPorPixel);
        let alturaCalculada = h + HEADER_ALTURA; // Misma altura que el contenedor

        let citasJSX = [];

        arrayCitas.map((agenda) => {  // ← Cambiado de "citas" a "agenda"
            console.log(agenda.id);
            const citasVisibles = (agenda.citas || []).filter((cita) => {
                const horaCita = parseInt(cita.hora_cita.split(':')[0], 10);
                return horaCita >= horaInicio && horaCita < horaFin;
            });
            const layoutCitas = calcularLayoutCitasSolapadas(citasVisibles);

            let bloqueRecurso = <div key={`agenda-col-${agenda.agenda_id || agenda.id}`} className="columna-recursos" onClick={(e) => handleClicCalendar(e, agenda)} style={{ height: alturaCalculada + 'px' }}>
                {/* Usar nombre_agenda en lugar de nombre */}
                <div className="encabezado-recurso">{agenda.nombre_agenda}</div>
                {
                    citasVisibles.map((cita, idx) => {
                        const nombreSimple = (cita.cita_paciente || cita.motivo_consulta || cita.descripcion_cita || cita.nombre || '').trim();
                        const nombreCompleto = `${cita.primer_nombre || ''} ${cita.primer_apellido || ''}`.trim();
                        const esBloqueo = Boolean(cita.bloqueo);
                        const textoCita = esBloqueo
                            ? 'Agenda Bloqueada'
                            : (nombreCompleto || nombreSimple || 'Cita');
                        const estiloSolape = obtenerEstiloSolape(layoutCitas[idx]);

                        return <div
                                key={`${cita.id}-${idx}`}
                                className="cita-recursos"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (!esBloqueo) handleClicCita(cita, agenda);
                                }}
                                onMouseEnter={(e) => !esBloqueo && handleMouseEnter(e, cita, agenda.nombre_agenda)}
                                onMouseLeave={handleMouseLeave}
                                style={{ 
                                    top: getPosYCita(cita, minutosPorPixel) + 'px', 
                                    height: getAlturaCita(cita, minutosPorPixel) + 'px', 
                                    backgroundColor: cita.color ? cita.color : '#b8b8b8',
                                    cursor: esBloqueo ? 'default' : 'pointer',
                                    ...estiloSolape
                                }}
                            >
                                {convertirHoraMilitarA12h(cita.hora_cita)} - {textoCita}
                            </div>
                    })
                }
            </div>;
            citasJSX.push(bloqueRecurso);
        })

        setContenidoRecursos(citasJSX);
    }


    function getPosYCita(cita, minutosPorPixel) {
        let tiempoInicio = (60 * parseInt(cita.hora_cita.split(':')[0])) + parseInt(cita.hora_cita.split(':')[1]);
        // ✅ Restar el offset del inicio configurado
        let minutosOffset = horaInicio * 60;
        let tiempoRelativo = tiempoInicio - minutosOffset;
        let posY = parseInt(tiempoRelativo / minutosPorPixel);
        return posY + HEADER_ALTURA;
    }

    function getAlturaCita(cita, minutosPorPixel) {
        let h = cita.duracion_cita;
        return parseInt(h / minutosPorPixel);
    }

    function getRangoMinutos(cita) {
        const [hh, mm] = (cita.hora_cita || '00:00:00').split(':').map((n) => parseInt(n, 10) || 0);
        const inicio = (hh * 60) + mm;
        const duracion = Math.max(parseInt(cita.duracion_cita, 10) || SLOT_DURACION, 1);
        return { inicio, fin: inicio + duracion };
    }

    function calcularLayoutCitasSolapadas(citas = []) {
        const resultado = new Array(citas.length).fill(null);
        const columnasFin = [];

        const orden = citas
            .map((cita, index) => ({ cita, index, ...getRangoMinutos(cita) }))
            .sort((a, b) => a.inicio - b.inicio || a.fin - b.fin);

        const activos = [];
        const grupos = [];
        let grupoActual = [];
        let maxFinGrupo = -1;

        orden.forEach((item) => {
            if (grupoActual.length === 0 || item.inicio < maxFinGrupo) {
                grupoActual.push(item);
                maxFinGrupo = Math.max(maxFinGrupo, item.fin);
            } else {
                grupos.push(grupoActual);
                grupoActual = [item];
                maxFinGrupo = item.fin;
            }
        });
        if (grupoActual.length > 0) grupos.push(grupoActual);

        grupos.forEach((grupo) => {
            columnasFin.length = 0;
            activos.length = 0;
            let maxColumnasGrupo = 1;

            grupo.forEach((item) => {
                for (let i = activos.length - 1; i >= 0; i -= 1) {
                    if (activos[i].fin <= item.inicio) activos.splice(i, 1);
                }

                let columna = 0;
                while (columna < columnasFin.length && columnasFin[columna] > item.inicio) {
                    columna += 1;
                }
                columnasFin[columna] = item.fin;
                activos.push({ fin: item.fin, columna });
                maxColumnasGrupo = Math.max(maxColumnasGrupo, columna + 1);
                resultado[item.index] = { columna, total: maxColumnasGrupo };
            });

            grupo.forEach((item) => {
                resultado[item.index] = {
                    columna: resultado[item.index]?.columna ?? 0,
                    total: maxColumnasGrupo
                };
            });
        });

        return resultado;
    }

    function obtenerEstiloSolape(layout) {
        if (!layout || layout.total <= 1) return {};
        const width = 100 / layout.total;
        return {
            width: `calc(${width}% - 2px)`,
            left: `calc(${layout.columna * width}% + 1px)`,
            zIndex: layout.columna + 1
        };
    }

    function formatearHoraEtiqueta(minutosAbsolutos) {
        const h24 = Math.floor(minutosAbsolutos / 60) % 24;
        const mm = minutosAbsolutos % 60;
        const h12 = h24 % 12 === 0 ? 12 : h24 % 12;
        const ampm = h24 < 12 ? 'AM' : 'PM';
        return `${h12}:${leadingZero(mm)} ${ampm}`;
    }

    function crearBloquesMinutos(duracionBloque, minutosPorPixel) {
        const step = Math.max(parseInt(duracionBloque, 10) || 30, 1);
        const minutosRango = (horaFin - horaInicio) * 60;
        let h = parseInt(minutosRango / minutosPorPixel, 10);
        const duracionBloquePixels = Math.max(parseInt(step / minutosPorPixel, 10), 1);
        const cantidadBloques = Math.max(Math.ceil(minutosRango / step), 0);

        setAlturaAgendaRecursos(h + HEADER_ALTURA);

        let bloques = `<div class="bloque-encabezado-spacer" style="height:${HEADER_ALTURA}px"></div>`;
        let etiquetas = '';

        for (let k = 0; k < cantidadBloques; k++) {
            const posYEtiqueta = HEADER_ALTURA + (k * duracionBloquePixels) + 4;
            const minutosAbsolutos = (horaInicio * 60) + (k * step);
            etiquetas += "<span class='etiqueta-hora' style='top: " + posYEtiqueta + "px'>" + formatearHoraEtiqueta(minutosAbsolutos) + "</span>";
            bloques += "<div class='bloque-minutos' style='height:" + duracionBloquePixels + "px; border-bottom: 1px solid #e1e1e1; width: 100%;'></div>";
        }

        setEtiquetasHoras(etiquetas);
        setBloquesMinutos(bloques);
    }

    function cargarCitas() {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                fecha: fechaAgendaRecursos
            }
        }

        axios.get('citas-profesionales-dia', config)
            .then(response => {
                if (response.status === 200) {
                    setTodosLosRecursos(response.data);
                    // Mantener selecciones actuales o seleccionar todas si es la primera carga
                    if (recursosSeleccionados.length === 0) {
                        const idsAgendas = response.data.map(agenda => agenda.agenda_id || agenda.id);
                        setRecursosSeleccionados(idsAgendas);
                    }
                }
            })
            .catch(error => console.log(error))
    }

    function handleClicCita(cita, agendaSeleccionada = null) {
        setDate(cita.fecha_cita);
        setTime(cita.hora_cita);

        const _citaPac = (cita.cita_paciente || '').trim();
        const _motivoCita = (cita.motivo_consulta || '').trim();
        const _descCita = (cita.descripcion_cita || '').trim();
        const _nombreSimpleFallback = _citaPac || _motivoCita || _descCita || (cita.nombre || '').trim();

        // Fallback: si no hay paciente vinculado, usar cita_paciente como nombre
        setPrimerNombre((cita.primer_nombre || '').trim() || _nombreSimpleFallback);
        setSegundoNombre(cita.segundo_nombre);
        setPrimerApellido((cita.primer_nombre || '').trim() ? cita.primer_apellido : '');
        setSegundoApellido(cita.segundo_apellido);
        setEmail(cita.email || cita.cita_email || '');
        setCelular(cita.celular || cita.cita_celular || cita.cita_telefono || '');
        setTipoDocumento(cita.tipo_documento);
        setNumeroDocumento(cita.numero_documento);
        setIdPaciente(cita.id_paciente);
        setEstadoPaciente(cita.estado !== undefined && cita.estado !== null && cita.estado !== '' ? String(cita.estado) : '');
        setDuracionCita(cita.duracion_cita);
        setEstadoCita(cita.estado_cita);
        setIdEstadoCita(cita.id_estado_cita);
        setUnidadAtencion(cita.id_unidad_atencion);
        setCitaPaciente(_nombreSimpleFallback);
        setDescripcionCita(_descCita || _motivoCita || _nombreSimpleFallback);

        // Si no hay paciente vinculado, usar motivo/descripcion de cita simple
        if (!(cita.primer_nombre || '').trim()) {
            setMotivoConsulta(_motivoCita || _descCita || _citaPac);
        } else {
            setMotivoConsulta(cita.motivo_consulta || _descCita);
        }

        setVerCita(true);
        setPrimeraVez(false);
        setIdCita(cita.id);
        setHoraAtencionCita(getElementosHora(cita.hora_cita)[0]);
        setMinutoCita(getElementosHora(cita.hora_cita)[1]);
        setAmpmCita(getElementosHora(cita.hora_cita)[2]);

        // Fallback: en vista por agendas, si la cita no trae id_users usar agenda de la columna clickeada
        setProfesionalAsignado(cita.id_users || agendaSeleccionada?.agenda_id || agendaSeleccionada?.id || '');

        setUsuarioAgenda(cita.id_usuario_asigna);

        // Usar nombre de agenda de la cita o de la columna clickeada
        setNombreProfesionalAsignado(cita.nombre_agenda || agendaSeleccionada?.nombre_agenda || 'Nombre no disponible');

        setNombreUsuarioAsigna((cita.nombre_usuario_agenda || '') + ' ' + (cita.apellido_usuario_agenda || ''));

        if (cita.estado == '1') {
            setPuedeAtender(true);
        }
        else {
            setPuedeAtender(false);
        }

        if (cita.estado_cita != null) {
            setModalState('visible');
        }
    }


    function toastCita(msg) {

        setToastMsg(msg);
        setTimeout(() => { setShowToast(true) }, 800);
    }

    // Funciones para manejar filtros de agendas
    const toggleRecurso = (agendaId) => {
        setRecursosSeleccionados(prev => {
            if (prev.includes(agendaId)) {
                return prev.filter(id => id !== agendaId);
            } else {
                return [...prev, agendaId];
            }
        });
    };

    const seleccionarTodas = () => {
        const idsAgendas = todosLosRecursos.map(agenda => agenda.agenda_id || agenda.id);
        setRecursosSeleccionados(idsAgendas);
    };

    const deseleccionarTodas = () => {
        setRecursosSeleccionados([]);
    };

    function handleMouseEnter(e, cita, fallbackAgenda = '') {
        clearTooltipHideTimer();

        const rect = e.currentTarget.getBoundingClientRect();
        const pos = calcularPosicionTooltipCita(rect, { esBloqueo: Boolean(cita.bloqueo) });
        const contenidott = buildCitaTooltipHtml(cita, { fallbackAgenda });

        setTooltipAnchor(rect);
        setContenidoTooltip(contenidott);
        setTooltipTop(pos.top);
        setTooltipLeft(pos.left);
        setTooltipDisplay('block');
    }

    function handleMouseLeave() {
        clearTooltipHideTimer();
        tooltipHideTimerRef.current = setTimeout(() => {
            setTooltipDisplay('none');
            setTooltipAnchor(null);
            tooltipHideTimerRef.current = null;
        }, 220);
    }

    const toggleMostrarFiltros = () => {
        setMostrarFiltros(!mostrarFiltros);
    };



    if (loggedIn) {

        return (
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="calendar" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/agenda">Agenda</Link></li>
                                        <li className="breadcrumb-item" key="bc3">Agenda por Profesionales</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Vista por Profesionales</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-md-12">

                                    <div className="row encabezado-agenda-recursos agenda-recursos-header">
                                        <div className="col-lg-2 col-md-3 col-12 navegacion-agenda-recursos fc-button-group">
                                            <button className="btn-atras" onClick={() => handleFecha(-1)}><span className="fc-icon fc-icon-chevron-left"></span></button>
                                            <button className="btn-adelante" onClick={() => handleFecha(1)}><span className="fc-icon fc-icon-chevron-right"></span></button>
                                        </div>
                                        <div className="col-lg-8 col-md-6 col-12 fecha-actual-agenda-recursos d-flex justify-content-center">
                                            <button type="button" className="agenda-date-chip agenda-date-chip-btn" onClick={abrirModalFecha}>
                                                <i className="far fa-calendar-alt"></i> {formatearFechaAmigable(fechaAgendaRecursos)}
                                            </button>
                                        </div>
                                        <div className="col-lg-2 col-md-3 col-12 text-right agenda-recursos-header-actions">
                                            <button
                                                className="btn btn-outline-info btn-sm agenda-filter-main-btn"
                                                onClick={toggleMostrarFiltros}
                                            >
                                                <i className="fas fa-filter"></i> Filtrar Agendas ({recursosSeleccionados.length}/{todosLosRecursos.length})
                                            </button>
                                        </div>
                                    </div>

                                    {/* Panel de Filtros */}
                                    {mostrarFiltros && (
                                        <div className="card card-info card-outline mb-3">
                                        <div className="card-header agenda-filter-card-header">
                                                <h5 className="card-title">
                                                    <i className="fas fa-filter"></i> Seleccionar Agendas a Mostrar
                                                </h5>
                                            <div className="card-tools agenda-filter-card-tools">
                                                    <button
                                                    className="btn btn-sm btn-outline-info mr-2"
                                                        onClick={seleccionarTodas}
                                                    >
                                                        <i className="fas fa-check-double"></i> Todas
                                                    </button>
                                                    <button
                                                    className="btn btn-sm btn-outline-secondary mr-2"
                                                        onClick={deseleccionarTodas}
                                                    >
                                                        <i className="fas fa-times"></i> Ninguna
                                                    </button>
                                                    <button
                                                    className="btn btn-sm btn-outline-dark"
                                                        onClick={toggleMostrarFiltros}
                                                    >
                                                        <i className="fas fa-times"></i>
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="card-body">
                                                <div className="row">
                                                    {todosLosRecursos.map((agenda, index) => (
                                                        <div key={agenda.agenda_id || agenda.id} className="col-md-3 col-sm-4 col-6 mb-2">
                                                            <div className="d-flex align-items-center">
                                                                <CustomSwitch
                                                                    onChange={() => toggleRecurso(agenda.agenda_id || agenda.id)}
                                                                    checked={recursosSeleccionados.includes(agenda.agenda_id || agenda.id)}
                                                                />
                                                                <span className="ml-2" style={{ fontSize: '14px' }} title={agenda.nombre_agenda}>
                                                                    {agenda.nombre_agenda && agenda.nombre_agenda.length > 20
                                                                        ? agenda.nombre_agenda.substring(0, 26) + '...'
                                                                        : agenda.nombre_agenda
                                                                    }
                                                                </span>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                                {todosLosRecursos.length === 0 && (
                                                    <div className="text-center text-muted">
                                                        <i className="fas fa-info-circle"></i> No hay agendas disponibles para esta fecha
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}

                                    <div className="contenedor-agenda-recursos" style={{ height: '75vh' }}>

                                        {/* COLUMNA DE HORAS (STICKY) */}
                                        <div className="columna-horas-sticky" dangerouslySetInnerHTML={{ __html: etiquetasHoras }}></div>

                                        {/* AREA DE CONTENIDO (GRID + COLUMNAS) */}
                                        <div className="area-contenido-agenda" style={{ height: alturaAgendaRecursos }}>

                                            {/* FONDO LINEAS (GRID) */}
                                            <div className="fondo-lineas-grid" dangerouslySetInnerHTML={{ __html: bloquesMinutos }}></div>

                                            {/* COLUMNAS DE RECURSOS */}
                                            <div className="flex-columnas-recursos">
                                                {contenidoRecursos}
                                            </div>

                                        </div>

                                    </div>

                                </div>
                            </div>

                        </div>
                    </section>
                </div>


                <FormNuevaCita
                    modalState={modalState}
                    closeModal={modalState => setModalState('hidden')}
                    profesionalAsignado={profesionalAsignado}
                    nombreProfesionalAsignado={nombreProfesionalAsignado}
                    usuarioAsigna={usuarioAgenda}
                    nombreUsuarioAsigna={nombreUsuarioAsigna}
                    fecha={date}
                    hora={time}
                    reloadCitasAgenda={cargarCitas}
                    extendedProps={extendedProps}
                    primerNombre={primerNombre}
                    segundoNombre={segundoNombre}
                    primerApellido={primerApellido}
                    segundoApellido={segundoApellido}
                    email={email}
                    celular={celular}
                    tipoDocumento={tipoDocumento}
                    numeroDocumento={numeroDocumento}
                    duracionCita={duracionCita}
                    estadoCita={idEstadoCita}
                    unidadAtencion={unidadAtencion}
                    motivoConsulta={motivoConsulta}
                    citaPaciente={citaPaciente}
                    descripcionCita={descripcionCita}
                    verCita={verCita}
                    puedeAtender={puedeAtender}
                    estadoPaciente={estadoPaciente}
                    idPaciente={idPaciente}
                    primeraVez={primeraVez}
                    idCita={idCita}
                    horaAtencionCita={horaAtencionCita}
                    minutoCita={minutoCita}
                    ampmCita={ampmCita}
                    agendarCitaPaciente={props.agendarCitaPaciente}
                    bloquearProfesional={props.bloquearProfesional}
                    stepCita={stepCita}
                    notificacionCita={toastCita}
                />

                <AgendaTooltip
                    top={tooltipTop}
                    left={tooltipLeft}
                    display={tooltipDisplay}
                    contenido={contenidoTooltip}
                    anchorRect={tooltipAnchor}
                />

                <Footer showToast={false} delay={0} />

                <Modal show={showDateModal} onHide={() => setShowDateModal(false)} centered dialogClassName="agenda-modern-modal">
                    <Modal.Header className="agenda-modern-modal__header">
                        <Modal.Title className="agenda-modern-modal__title">
                            <span className="agenda-modern-modal__title-icon"><i className="far fa-calendar-alt"></i></span>
                            Seleccionar Fecha
                        </Modal.Title>
                        <button type="button" className="agenda-modern-modal__close" onClick={() => setShowDateModal(false)}>
                            <i className="fas fa-times"></i>
                        </button>
                    </Modal.Header>
                    <Modal.Body className="agenda-modern-modal__body">
                        <div className="form-group mb-3">
                            <label>Fecha</label>
                            <input
                                type="date"
                                className="form-control agenda-modern-control"
                                value={fechaModal || ''}
                                onChange={(e) => setFechaModal(e.target.value)}
                            />
                        </div>
                        <div className="d-flex">
                            <button type="button" className="btn btn-outline-secondary mr-2" onClick={irHoyDesdeModal}>Hoy</button>
                            <button type="button" className="btn btn-outline-dark mr-2" onClick={() => setShowDateModal(false)}>Cancelar</button>
                            <button type="button" className="btn btn-info ml-auto" onClick={aplicarFechaModal}>Aplicar</button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }

    return (
        <Loading />
    );
}
export default VistaPorRecursos;